export interface FormControlModel {
  key: string;
  label: string;
  controlType: 'textfield' | 'textarea' | 'dropdown' | 'datepicker' | 'readonly' | 'radio';
  value?: string | boolean | number;
  position?: number;
  showFilterButton?: boolean;
  dependsOn?: string;
  placeHolder?: string;
  required?: boolean;
  maxLength?: number;
  minLength?: number;
  fullRow?: boolean;
}

export const REQUIRED_CTRLS: FormControlModel[] = [
  {
    key: 'assessmentType',
    label: 'distribution.assessmentType',
    controlType: 'dropdown',
    position: 0,
    placeHolder: 'distribution.selectAssessmentType',
    required: true
  },
  {
    key: 'template',
    label: 'distribution.template',
    controlType: 'dropdown',
    position: 1,
    showFilterButton: true,
    dependsOn: 'assessmentType',
    placeHolder: 'distribution.selectTemplate',
    required: true
  },
  {
    key: 'formula',
    label: 'distribution.formula',
    controlType: 'dropdown',
    position: 2,
    dependsOn: 'assessmentType',
    placeHolder: 'distribution.selectFormula',
    required: true
  },
  {
    key: 'dueDate',
    label: 'distribution.dueDate',
    controlType: 'datepicker',
    position: 3,
    dependsOn: 'assessmentType'
  }
];
